module.exports = __webpack_public_path__ + "img/s2.ee772bba.svg";